import React, { useState } from "react";
import { Modal, Form, Row, Col, Button, Table, message } from 'antd';
import { config } from "util/config";
import { httpClient } from 'util/Api';
import { useHistory } from "react-router-dom";
import * as globalFunction from 'util/GlobalFunction';
import AppNotificationContainer from 'components/AppNotificationContainer';
import PaymentHeader from '../Header';

const Quote = () => {
  const history = useHistory();
  let pathname = window.location.pathname.split('/');

  //以React.FC为页面入口获取当前用户信息，创建React.Component页面
  return (
    <QuotePage quoteId={pathname[pathname.length - 1]} history={history} />
  )
}
export default Quote;

class QuotePage extends React.Component {
  constructor(props) {
    super();
    this.state = {
      quote: null,
      submitting: false,
      getSessionSuccess: false
    }
  }

  componentDidMount() {
    this.addScript('https://anzworldline.gateway.mastercard.com/static/checkout/checkout.min.js');
    this.getQuote();
  }

  getQuote() {
    httpClient
      .get('/PublicPayment/MPGS/GetQuote/' + this.props.quoteId)
      .then(({ data }) => {
        if (data.result) {
          this.setState({ quote: data.data });
        } else {
          message.error(data.message);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, this);
      });
  }

  getPaymentSession() {
    this.setState({ submitting: true });
    httpClient
      .get('/PublicPayment/MPGS/GetQuoteOrderSession/' + this.props.quoteId)
      .then(({ data }) => {
        if (data.result) {
          this.setState({ submitting: false, getSessionSuccess: true });
          window.Checkout.configure({ session: { id: data.data } });
          window.Checkout.showEmbeddedPage('#embed-target');
          // window.Checkout.showPaymentPage();
        } else {
          message.error(data.message);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, this);
      });
  }

  addScript = (src) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.setAttribute('data-error', 'errorCallback');
    script.setAttribute('data-cancel', 'cancelCallback');

    document.body.appendChild(script);

    script.onload = () => {
      // Script loaded successfully
      console.log('Script loaded successfully.');
    };

    script.onerror = () => {
      // Handle script loading error
      console.log('Error loading script.');
    };
  }

  errorCallback = () => {
    // 错误回调函数
    console.log('Error callback function');
  }

  cancelCallback = () => {
    // 取消回调函数
    console.log('Cancel callback function');
  }


  render() {
    return (
      <>
        {
          this.state.quote !== null ?
            <div>
              <div className='public-payment-div' style={{ padding: '20px' }}>
                <Row gutter={config.component.gutter}>
                  {/* 与 NAB 付款页共用公司/模块对应的页头，避免两套付款入口显示不一致。 */}
                  <PaymentHeader job={this.state.quote.Job} />
                  <Col span={24} style={{ marginTop: '10px' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '18px' }}>Quote {this.state.quote.QuoteNumber}</span>
                  </Col>
                  <Col span={24}>
                    <span><span style={{ fontWeight: 'bold' }}>Date:</span> {globalFunction.truncateString(this.state.quote.Date, 10)}</span>
                  </Col>
                  <Col span={24}>
                    <span><span style={{ fontWeight: 'bold' }}>Expiry Date:</span> {globalFunction.truncateString(this.state.quote.ExpiryDate, 10)}</span>
                  </Col>
                  <Col span={24}>
                    <span><span style={{ fontWeight: 'bold' }}>Quote To:</span> {this.state.quote.Job.Applicant?.FullNameCompany}</span>
                  </Col>
                  <Col span={24}>
                    <span><span style={{ fontWeight: 'bold' }}>Job No.:</span> {this.state.quote.Job.JobNum}</span>
                  </Col>
                  <Col span={24}>
                    <span><span style={{ fontWeight: 'bold' }}>Work Description:</span> {this.state.quote.Job.WorkDescription}</span>
                  </Col>
                  <Col span={24} style={{ marginTop: '10px' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '18px' }}>Quote Details</span>
                  </Col>
                  <Col span={24}>
                    <Table
                      bordered
                      className='vertical-align-top-table'
                      pagination={false}
                      size="small"
                      dataSource={this.state.quote.QuoteLineItemList}
                      columns={[
                        {
                          title: 'Description',
                          dataIndex: 'Description',
                        },
                        {
                          title: 'Qty',
                          dataIndex: 'Quantity',
                        },
                        {
                          title: 'Unit Amount',
                          dataIndex: 'DiscountUnitAmount',
                          align: 'right',
                          render: (data, record) => <>{globalFunction.formatMoney(data)}</>
                        },
                        {
                          title: 'GST',
                          dataIndex: 'TaxAmount',
                          align: 'right',
                          render: (data, record) => <>{globalFunction.formatMoney(data)}</>
                        },
                        {
                          title: 'Amount',
                          dataIndex: 'Total',
                          align: 'right',
                          render: (data, record) => <>{globalFunction.formatMoney(data)}</>
                        }
                      ]}
                    />
                  </Col>
                  <Col span={24} style={{ textAlign: 'center', marginTop: '10px' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '18px' }}>Quote Total: {globalFunction.formatMoney(this.state.quote.Total)}</span>
                  </Col>
                  <Col span={24} style={{ textAlign: 'center', marginTop: '10px' }}>
                    <Button type="primary"
                      style={{ width: '30%', minWidth: '200px' }}
                      loading={this.state.submitting}
                      disabled={this.state.submitting}
                      hidden={this.state.getSessionSuccess}
                      onClick={() => {
                        this.getPaymentSession();
                      }}>
                      Pay Now
                    </Button>
                  </Col>
                </Row>
                <div id="embed-target" style={{ marginTop: '10px' }}></div>
              </div>
            </div> : <AppNotificationContainer loading={this.state.quote == null} error={''} />
        }
      </>
    );
  }
};
